/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Imports */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

import "../../webpack/node_modules/intersection-observer";
import "../../webpack/node_modules/lazysizes";
import {
  TweenMax,
  TimelineMax,
  ScrollToPlugin,
  Draggable,
  CSSPlugin,
} from "../../webpack/node_modules/gsap/all";

import { debounce, addListenerMulti, convertRemToPixels } from "./helpers";

// Initialize Plugins to avoid tree shaking issues
const plugins = [ScrollToPlugin, CSSPlugin];
const axios = require("../../webpack/node_modules/axios");

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Variables */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

const header = document.querySelector("header"),
  body = document.querySelector("body"),
  main = document.querySelector("main"),
  footer = document.querySelector("footer");

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Animation */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

function initAnimation() {
  let overlay = document.querySelector("#overlay");
  let overlayH1 = document.querySelectorAll("#overlay h1")[0];
  let realH1 = document.querySelectorAll("header h1")[0];

  let mq = window.matchMedia("(min-width: 1024px)");
  if (mq.matches) {
    TweenMax.set(realH1, { opacity: 0 });
    TweenMax.to(overlay, 0.6, {
      css: { className: "+=hidden" },
      ease: Power4.easeInOut,
      beforeStart: function () {
        TweenMax.to(overlayH1, 0.3, {
          css: { className: "+=hidden" },
          ease: Power4.easeInOut,
        });
      },
      onComplete: function () {
        TweenMax.to(overlayH1, 0.5, {
          delay: 0.3,
          opacity: 0,
          onComplete: function () {
            overlay.parentNode.removeChild(overlay);
          },
        });
        TweenMax.to(realH1, 1, { delay: 0.55, opacity: 1 });
      },
    });
  } else {
    overlay.parentNode.removeChild(overlay);
  }
}

// document.addEventListener("DOMContentLoaded", initAnimation);
// window.addEventListener("load", initAnimation);

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Smooth Scroll */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

let scrollLinks = document.querySelectorAll("a[href^='#']");
scrollLinks.forEach((scrollLink) => {
  let target = scrollLink.getAttribute("href");
  scrollLink.addEventListener("click", function (e) {
    e.preventDefault();
    toggleAccordion(document.querySelector("nav"));
    scrollTo(target);
  });
});

function scrollTo(target) {
  let offset = header.offsetHeight;
  TweenMax.to(window, 0.4, {
    scrollTo: {
      y: target,
      offsetY: parseInt(offset, 10),
      autoKill: false,
    },
    delay: 0.2,
    onComplete: function () {},
  });
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Accordion(s) */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

function initAccordions() {
  let accordionToggles = document.querySelectorAll(".accordion__toggle");
  if (accordionToggles !== null) {
    accordionToggles.forEach((accordionToggle) =>
      accordionToggle.addEventListener("click", function () {
        toggleAccordion(accordionToggle.closest(".accordion"), accordionToggle);
      })
    );
  }
}

function toggleAccordion(accordion, accordionToggle) {
  let accordionContent = accordion.querySelectorAll(".accordion__content")[0];

  if (accordionContent.classList.contains("accordion__content--hidden")) {
    if (
      accordionToggle !== undefined &&
      accordionToggle.dataset.close !== undefined
    ) {
      accordionToggle.innerHTML = accordionToggle.dataset.close;
    }
    openAccordion(accordion, accordionToggle);
  } else {
    closeAccordion(accordion, accordionToggle);
    if (
      accordionToggle !== undefined &&
      accordionToggle.dataset.open !== undefined
    ) {
      accordionToggle.innerHTML = accordionToggle.dataset.open;
    }
  }
}

function openAccordion(accordion, accordionToggle) {
  let accordionContent = accordion.querySelectorAll(".accordion__content")[0];

  accordion.classList.add("accordion--visible");
  accordion.classList.remove("accordion--hidden");

  TweenMax.to(accordionContent, 0.3, {
    css: { className: "-=accordion__content--hidden" },
    ease: Power4.easeInOut,
    onComplete: function () {
      TweenMax.to(accordionContent, 0.3, { opacity: 1 });
    },
  });
  accordionContent.classList.add("accordion__content--visible");
}

function closeAccordion(accordion, accordionToggle) {
  let accordionContent = accordion.querySelectorAll(".accordion__content")[0];
  accordionContent.classList.remove("accordion__item--visible");
  TweenMax.to(accordionContent, 0.1, { opacity: 0, ease: Power4.easeOut });
  TweenMax.to(accordionContent, 0.3, {
    height: 0,
    ease: Power4.easeOut,
    delay: 0.1,
    onComplete: function () {
      accordion.classList.add("accordion--hidden");
      accordion.classList.remove("accordion--visible");
      accordionContent.setAttribute("style", "");
      accordionContent.classList.add("accordion__content--hidden");
      accordionContent.classList.remove("accordion__content--visible");
    },
  });
}

document.addEventListener("DOMContentLoaded", initAccordions);

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Menu */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

function initMenu() {
  document.querySelector("#btn__menu").addEventListener("click", function () {
    this.closest("header").classList.toggle("menu--active");
    toggleAccordion(document.querySelector("nav"), this);
  });
}

document.addEventListener("DOMContentLoaded", initMenu);

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Youtube */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

function playVideo() {
  let video = this.closest(".video");
  video.classList.add("video--loading");
  let iframe = video.querySelectorAll("iframe")[0];
  iframe.src = iframe.getAttribute("data-src");
  let playButton = this;
  let player = new YT.Player(iframe, {
    playerVars: {
      autohide: 1,
      wmode: "opaque",
      origin: window.location,
      enablejsapi: 1,
    },
    host: `${window.location.protocol}//www.youtube.com`,
    events: {
      // call this function when player is ready to use
      onReady: function () {
        player.playVideo();
        //video.classList.remove("video--loading");
        video.classList.add("video--loaded");
      },
    },
  });

  // console.log(iframe, this);
  // iframe.src = iframe.getAttribute("data-src");
  // this.parentNode.classList.add("video--loaded");
}

function onPlayerReady(playButton, player) {
  playButton.addEventListener("click", function () {
    player.playVideo();
  });
}

let tag = document.createElement("script");
tag.src = "//www.youtube.com/player_api";
let firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let videoBTNs = document.querySelectorAll(".btn__video");

if (document.body.contains(videoBTNs[0])) {
  videoBTNs.forEach((videoBTN) => {
    videoBTN.addEventListener("click", playVideo);
  });
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Audio */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

// Logic
let i = 0;

function n(n) {
  return n > 9 ? "" + n : "0" + n;
}

function setTime(time) {
  let s = parseInt(time % 60),
    m = parseInt((time / 60) % 60);
  return n(m) + ":" + n(s);
}

function timeToSeconds(time) {
  return time.split(":").reduce((acc, time) => 60 * acc + +time);
}

function initMedia() {
  let tracks = document.querySelectorAll(".playlist__track");
  let playlist = [];
  [...tracks].forEach((track) => {
    playlist.push(track);
  });

  //   console.log(tracks);

  // let progress = document.querySelector(".media__progress");
  let toggles = document.querySelectorAll(".media__play-pause"),
    trackLinks = document.querySelectorAll("[data-track]");
  // let btnNext = document.querySelector(".media__next"),
  // btnPrev = document.querySelector(".media__prev"),
  //seekBar = document.querySelector(".media__progress input");

  function togglePlay() {
    let playState = playlist[i].paused ? "play" : "pause";
    playlist[i][playState](); // Call play or paused method
    updateState();
  }

  function updateInfo() {
    let album = playlist[i].dataset.album;
    let title = playlist[i].dataset.title,
      currAlbums = document.querySelectorAll(".media__current__album"),
      currTitles = document.querySelectorAll(".media__current__title");
    [...currAlbums].forEach((currAlbum) => {
      currAlbum.innerHTML = album;
    });
    [...currTitles].forEach((currTitle) => {
      currTitle.innerHTML = title;
    });
    // console.log("update!");
    // progressUpdate();
    initTicker();
  }

  function anyPlaying() {
    let plLength = playlist.length;
    while (plLength--) {
      if (!playlist[plLength].paused) {
        return true;
      }
    }
    return false;
  }

  function updateState() {
    if (!body.classList.contains("player--active")) {
      body.classList.add("player--active");
    }

    let currSrc = playlist[i].children[0].src;
    let currPlaying = document.querySelectorAll(".track--playing")[0];

    if (currPlaying !== undefined) {
      currPlaying.classList.remove("track--playing");
    }

    if (anyPlaying()) {
      document
        .querySelector('[data-track="' + currSrc + '"]')
        .classList.add("track--playing");
      body.classList.add("media--playing");
    } else {
      body.classList.remove("media--playing");
    }
  }

  function progressUpdate() {
    let percent = (playlist[i].currentTime / playlist[i].duration) * 100;
    seekBar.value = percent;
    seekBar.setAttribute("value", percent);
    progress.style.setProperty("--progress", `${percent}%`);
  }

  function scrub(e) {
    let scrubTime = (e.offsetX / progress.offsetWidth) * playlist[i].duration;
    playlist[i].currentTime = scrubTime;
  }

  function playNext() {
    playlist[i].pause();
    playlist[i].currentTime = 0;
    if (i === playlist.length - 1) {
      i = 0;
    } else {
      i++;
    }
    // console.log(i);
    playlist[i].play();
    updateInfo();
  }

  function playPrev() {
    playlist[i].pause();
    playlist[i].currentTime = 0;
    if (i === 0) {
      i = playlist.length - 1;
    } else {
      i--;
    }
    // console.log(i);
    playlist[i].play();
    updateInfo();
  }

  function playTarget(target) {
    playlist[i].pause();
    playlist[i].currentTime = 0;
    i = target;
    playlist[i].play();
    updateInfo();
  }

  // Event listeners

  playlist[0] && playlist[0].addEventListener("loadeddata", updateInfo);

  [...playlist].forEach((track) => {
    track.addEventListener("ended", playNext);
    track.addEventListener("play", updateState);
    track.addEventListener("pause", updateState);
    //track.addEventListener("timeupdate", progressUpdate);
  });

  // btnNext.addEventListener("click", playNext);
  // btnPrev.addEventListener("click", playPrev);

  if (toggles !== null) {
    toggles.forEach((toggle) => toggle.addEventListener("click", togglePlay));
  }

  if (trackLinks !== null) {
    trackLinks.forEach((trackLink) =>
      trackLink.addEventListener("click", function () {
        let currSrc = playlist[i].children[0].src;
        let url = trackLink.dataset.track;

        // console.log(currSrc, url);

        let audioRef = document
          .querySelector('source[src~="' + url + '"]')
          .closest("li");
        // console.log(audioRef);

        let target = [...audioRef.parentElement.children].indexOf(audioRef);
        if (url !== currSrc || playlist[i].paused) {
          playTarget(target);
        } else {
          playlist[i].pause();
        }
      })
    );
  }

  //progress.addEventListener("click", scrub);
  // let mousedown = false;
  // progress.addEventListener("click", scrub);
  // progress.addEventListener("mousemove", e => mousedown && scrub(e));
  // progress.addEventListener("click", e => mousedown && scrub(e));
  // progress.addEventListener("mousedown", () => (mousedown = true));
  // progress.addEventListener("mouseup", () => (mousedown = false));

  // $(".reference").each(function() {
  //     let $this = $(this);
  //     let ref = $this.data("ref");

  //     let trackID = $("#tracks")
  //         .find('li[data-ref="' + ref + '"]')
  //         .index();

  //     $this.attr("data-target", trackID);
  // });

  // $(".reference").on("click", function() {
  //     let target = $(this).data("target");
  //     playTarget(target);
  //     changeColor("fwd");
  // });
}

document.addEventListener("DOMContentLoaded", initMedia);

function initTicker() {
  var container = document.querySelectorAll(".ticker__container");
  document
    .querySelectorAll(".ticker--clone")
    .forEach((e) => e.parentNode.removeChild(e));

  [...container].forEach((el) => {
    var wrapper = el.querySelector(".ticker__wrapper");
    var containerWidth = el.clientWidth;
    var list = el.querySelector(".ticker__content");
    var listWidth = list.clientWidth;
    var cloneNum = Math.ceil(containerWidth / listWidth);

    var listClone;
    for (var i = 0; i < cloneNum; i++) {
      listClone = list.cloneNode(true); // the true is for deep cloning
      listClone.classList.add("ticker--clone");
      wrapper.appendChild(listClone);
    }

    var ticker = new TimelineMax({ repeat: -1, paused: false });
    var duration = (listWidth / containerWidth) * 15;
    ticker
      .fromTo(
        wrapper,
        duration,
        { x: 0 },
        { x: -listWidth, ease: Linear.easeNone },
        0
      )
      .set(list, { x: 0 });
  });
}

window.addEventListener("resize", initTicker);

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* Idle Animation */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
let inactivityTime = function () {
  let time;
  window.onload = resetTimer;
  // DOM Events
  document.onmousemove = resetTimer;
  document.onkeypress = resetTimer;

  function idleMode() {
    body.classList.add("idle--active");
  }

  function resetTimer() {
    if (body.classList.contains("idle--active")) {
      body.classList.remove("idle--active");
    }
    clearTimeout(time);
    time = setTimeout(idleMode, 30000);
    // 1000 milliseconds = 1 second
  }

  window.addEventListener("load", resetTimer, true);
  let events = ["mousedown", "mousemove", "keypress", "scroll", "touchstart"];
  events.forEach(function (name) {
    document.addEventListener(name, resetTimer, true);
  });
};

document.addEventListener("DOMContentLoaded", inactivityTime);
